(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/models/swipe.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/models/swipe.js'); 
'use strict';

svs.sport.result_boxes.models.Swipe = Backbone.Model.extend({
  defaults: {
    winAmount: 0,
    numCorrect: 0,
    hasWon: false,
    drawState: 'Closed',
    productName: '',
    payouts: [
      {
        correctNumber: 13,
        winValue: 0,
        winners: 0
      },
      {
        correctNumber: 12,
        winValue: 0,
        winners: 0
      },
      {
        correctNumber: 11,
        winValue: 0,
        winners: 0
      },
      {
        correctNumber: 10,
        winValue: 0,
        winners: 0
      }
    ],
    wins: [],
    numOfMatches: 0,
    playerForecastSync: false,
    jackpotValue: '',
    drawStateId: 0,
    cancelCloseTime: '12:00',
    bestRowModel: null,
    startGame: false,
    correctRowModel: null,
    totalRefund: null
  },

  initialize: function() {
    var self = this;
    this.setupFromForecast();
    this.setupDraw();
    this.set(
      'jackpotValue',
        _.isUndefined(this.get('jackPotValue')) ? '' : this.get('jackPotValue')
    );
    this.set(
      'jackpotValue',
        _.isUndefined(this.get('jackPotValue')) ? '' : this.get('jackPotValue')
    );
    this.set(
      'productClassName',
      this.get('productName')
        .replace('å', 'a')
        .toLowerCase()
    );

    if (this.get('refunds')) this.set('totalRefund', this.totalRefunds());

    if (this.get('bestRowModel')) {
      this.set('bestRowModel', this.get('bestRowModel'));

      this.get('bestRowModel').on('topDone', function() {
        self.setWins();
      });
    }

    this.get('draw').on('change', function(changes) {
      self.changeDraw(changes);
    });

    if (this.get('correctRows') && this.get('correctRows').length > 0) {
      this.set(
        'correctRowModel',
        new svs.sport.result_boxes.models.CorrectRow(
          this.get('correctRows'),
          this.isFinished()
        )
      );
    }

    if (
      this.get('productName').toLowerCase() ===
        svs.sport.result_boxes.constants.productName.BOMBEN
    ) {
      this.set('sportName', this.getSportName(), { silent: true });
    }
  },

  setupFromForecast: function() {
    var _self = this;
    this.setForecastValues(this.get('forecast'));
    if (this.get('forecast')) {
      this.get('forecast').on('change', function(change) {
        _self.forecastUpdated(change);
      });
    }
  },

  setupDraw: function() {
    var drawState = !_.isUndefined(this.get('draw').get('draw'))
          ? this.get('draw').get('draw').drawState
          : this.get('draw').get('drawState'),
      drawStateId = !_.isUndefined(this.get('draw').get('draw'))
          ? this.get('draw').get('draw').drawStateId
          : this.get('draw').get('drawStateId'),
      cancelCloseTime = !_.isUndefined(this.get('draw').get('draw'))
          ? this.get('draw').get('draw').cancelCloseTime
          : this.get('draw').get('cancelCloseTime'),
      weekNumber = svs.utils.date.WeekNr(cancelCloseTime),
      currentNetSale = !_.isUndefined(this.get('draw').get('draw'))
          ? this.getCurrentNetSale(this.get('draw').get('draw'))
          : this.getCurrentNetSale(this.get('draw').toJSON()),
      startTime = svs.utils.date.getWeekdayAndTime(cancelCloseTime),
      drawNumber = !_.isUndefined(this.get('draw').get('draw'))
          ? this.get('draw').get('draw').drawNumber
          : this.get('draw').get('drawNumber');

    this.set({
      drawState: drawState,
      drawStateId: drawStateId,
      cancelCloseTime: cancelCloseTime,
      weekNumber: weekNumber,
      currentNetSale: currentNetSale,
      startTime: startTime,
      extraMoney: this.getExtraMoney(),
      drawNumber: drawNumber,
      extraMoneyInfo: this.getExtraMoneyInfo()
    });
  },

  totalRefunds: function() {
    var totalRefund = 0;
    this.get('refunds').forEach(function(refund) {
      totalRefund += parseInt(refund.amount, 10);
    });

    return totalRefund;
  },

  changeDraw: function(changes) {
    var drawState = !_.isUndefined(changes.get('drawState'))
          ? changes.get('drawState')
          : this.get('drawState'),
      drawStateId = !_.isUndefined(changes.get('drawStateId'))
          ? changes.get('drawStateId')
          : this.get('drawStateId'),
      cancelCloseTime = !_.isUndefined(changes.get('cancelCloseTime'))
          ? changes.get('cancelCloseTime')
          : this.get('cancelCloseTime'),
      weekNumber = svs.utils.date.WeekNr(cancelCloseTime),
      currentNetSale = !_.isUndefined(changes.get('currentNetSale'))
          ? changes.get('currentNetSale')
          : this.get('currentNetSale'),
      startTime = svs.utils.date.getWeekdayAndTime(cancelCloseTime),
      drawNumber = !_.isUndefined(changes.get('drawNumber'))
          ? changes.get('drawNumber')
          : this.get('drawNumber');

    this.set({
      drawState: drawState,
      drawStateId: drawStateId,
      cancelCloseTime: cancelCloseTime,
      weekNumber: weekNumber,
      currentNetSale: currentNetSale,
      startTime: startTime,
      extraMoney: this.getExtraMoney(),
      drawNumber: drawNumber,
      extraMoneyInfo: this.getExtraMoneyInfo()
    });
  },

  forecastUpdated: function(result) {
    this.setForecastValues(result);

    if (this.get('hasWon') && this.get('bestRowModel') !== null) {
      if (this.get('bestRowModel').hasTopCorrects) {
        this.setWins();
      }
    } else if (this.get('hasWon')) {
      var wins = result.get('winresult').filter(function(res) {
        return res.isUsersScore === true;
      });

      this.set('wins', wins);
    } else if (
      this.get('bestRowModel') !== null &&
        this.get('bestRowModel').topCorrect.length > 0
    ) {
      this.setWins();
    }
  },

  setForecastValues: function(forecast) {
    var payouts =
          forecast && forecast.get('winresult')
            ? this.handlePayouts(forecast)
            : [],
      numCorrect =
          forecast && forecast.get('numCorrect')
            ? forecast.get('numCorrect')
            : 0,
      winAmount =
          forecast && forecast.get('winAmount') ? forecast.get('winAmount') : 0,
      hasWon =
          forecast && forecast.get('hasWon') ? forecast.get('hasWon') : false,
      wins = [];

    if (
      forecast &&
        this.get('productName').toLowerCase() ===
          svs.sport.result_boxes.constants.productName.BOMBEN &&
        forecast.get('hasWon')
    ) {
      if (forecast.get('winresult') && forecast.get('winresult').length > 0) {
        forecast.get('winresult').forEach(function(win) {
          if (win) {
            win.isUsersScore = true;
          }
        });
      }
    }

    if (forecast && forecast.get('winresult')) {
      wins = forecast.get('winresult').filter(function(res) {
        return res.isUsersScore === true;
      });
    }

    this.set({
      numCorrect: numCorrect,
      winAmount: winAmount,
      hasWon: hasWon,
      payouts: payouts,
      wins: wins
    });
  },

  setWins: function() {
    var wins = [];
    for (var i = 0; i < this.get('bestRowModel').topCorrect.length; i++) {
      if (
        this.get('bestRowModel').topCorrect[i] > 0 &&
          this.get('payouts') &&
          this.get('payouts')[i]
      ) {
        wins.push({
          correctNumber: this.get('payouts')[i].correctNumber,
          winValue: this.get('payouts')[i].winValue,
          nrOfWins: this.get('bestRowModel').topCorrect[i]
        });
      }
    }

    this.set('wins', wins);
  },

  hasNotStarted: function() {
    return (
      !this.get('startGame') &&
        (this.get('drawState') === 'Open' ||
          this.get('drawStateId') ===
            svs.sport.result_boxes.constants.REGCLOSED)
    );
  },

  hasFinishedOrRunning: function() {
    return (
      this.get('startGame') ||
        this.get('drawStateId') ===
          svs.sport.result_boxes.constants.CANCELCLOSED ||
        this.get('drawState') === 'Finalized' ||
        this.get('drawState') === 'Closed'
    );
  },

  formatCurrentNetSale: function(unFormattedNetSale) {
    var formattedNetSale;
    formattedNetSale =
        svs.utils.format.Currency(unFormattedNetSale, false) + ' kr';

    return formattedNetSale;
  },

  isFinished: function() {
    return this.get('drawState') === 'Finalized';
  },

  getExtraMoney: function() {
    var extraMoney,
      currentFund = this.get('draw').get('fund');

    if (currentFund) {
      if (
        currentFund.extraMoney &&
          parseInt(currentFund.extraMoney, 10) > 0
      ) {
        extraMoney =
            svs.utils.format.Currency(parseInt(currentFund.extraMoney, 10)) +
            ' kr';
      } else if (
        currentFund.rolloverIn &&
          parseInt(currentFund.rolloverIn, 10) > 0
      ) {
        extraMoney =
            svs.utils.format.Currency(parseInt(currentFund.rolloverIn, 10)) +
            ' kr';
      }
    }
    return extraMoney;
  },

  handlePayouts: function(forecast) {
    var payouts = forecast.get('winresult');

    if (
      this.get('productName').toLowerCase() ===
          svs.sport.result_boxes.constants.productName.BOMBEN &&
        payouts
    ) {
      payouts[0].correctNumber = forecast.get('drawResults').length;
    }

    return payouts;
  },

  getCurrentNetSale: function(draw) {
    var currentNetSale = draw.currentNetSale || draw.currentNetSales;
    return this.formatCurrentNetSale(currentNetSale);
  },

  getExtraMoneyInfo: function() {
    var extraMoney,
      extraMoneyInfo,
      currentFund = this.get('draw').get('fund');

    if (currentFund) {
      if (
        currentFund.extraMoney &&
          parseInt(currentFund.extraMoney, 10) > 0
      ) {
        extraMoney =
            svs.utils.format.Currency(parseInt(currentFund.extraMoney, 10)) +
            ' kr';
        extraMoneyInfo = 'Extrapengar: ' + extraMoney;
      } else if (
        currentFund.rolloverIn &&
          parseInt(currentFund.rolloverIn, 10) > 0
      ) {
        extraMoney =
            svs.utils.format.Currency(parseInt(currentFund.rolloverIn, 10)) +
            ' kr';
        extraMoneyInfo = 'Rullpott: ' + extraMoney;
      }
    }
    return extraMoneyInfo;
  },

  getSportName: function() {
    var sportName = '';

    switch (this.get('draw').get('sport').id) {
      case svs.sport.result_boxes.constants.sports.FOTBOLL:
        return 'fotboll';
      case svs.sport.result_boxes.constants.sports.HOCKEY:
        return 'hockey';
      default:
    }

    return sportName;
  }
});

 })(window);